<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-job-description-details',
};
</script>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/page-job-description-details.vue